/**
 * Column class
 *
 * @package    DataTable
 * @author     Maxim Lukianenko <mlukianenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';

import Order from './Order';
import { DataTableColumnType } from 'Types';
import { DATA_TABLE_COLUMN_TYPE_HIDDEN } from 'Constants';

export default class Column extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        column: DataTableColumnType.isRequired,
        order: PropTypes.string,
        setOrder: PropTypes.func.isRequired,
    };

    /**
     * DefaultProps
     */
    static defaultProps = {
        order: '',
    };

    render() {
        const { column, setOrder, order } = this.props;
        const { title, sortable } = column;

        if (column.type === DATA_TABLE_COLUMN_TYPE_HIDDEN) {
            return null;
        }

        return (
            <TableCell>
                {sortable && (
                    <Tooltip title="Sort" placement="bottom-start" enterDelay={300}>
                        <Order column={column} order={order} setOrder={setOrder} />
                    </Tooltip>
                )}
                {!sortable && <FormattedMessage id={title} />}
            </TableCell>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableHead/Column.jsx